import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class Sector extends ModelBase {
    static typeName = "Sector";

    public sectorId: number = 0;

    @Rules.StringLength(3)
    @Rules.Required()
    public sectorCode: string = "";

    @Rules.StringLength(100)
    @Rules.Required()
    @Attributes.Display("Sector")
    @Attributes.DisplayMember()
    public sectorName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
      if (this.isNew || !this.sectorName) {
            return "New sector";
        } else {
        return this.sectorName;
        }
    }
}